const API_BASE_URL = process.env.VUE_APP_API_URL || window.location.origin

class ApiClient {
  constructor() {
    this.baseUrl = API_BASE_URL
    this.token = localStorage.getItem('token') || null
  }

  // 设置认证令牌
  setToken(token) {
    this.token = token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  }

  // 获取认证头
  getAuthHeaders() {
    const headers = {
      'Content-Type': 'application/json'
    }
    
    if (this.token) {
      headers.Authorization = `Bearer ${this.token}`
    }
    
    return headers
  }

  // 通用请求方法
  async request(url, options = {}) {
    const headers = this.getAuthHeaders()
    
    try {
      const response = await fetch(`${this.baseUrl}${url}`, {
        ...options,
        headers: {
          ...headers,
          ...options.headers
        }
      })
      
      const data = await response.json()
      
      if (!response.ok) {
        // 如果是401错误，清除token并重定向到登录页
        if (response.status === 401) {
          this.setToken(null)
          localStorage.removeItem('user')
          if (typeof window !== 'undefined') {
            window.location.href = '/login'
          }
        }
        throw new Error(data.error || '请求失败')
      }
      
      return data
    } catch (error) {
      console.error('API请求错误:', error)
      throw error
    }
  }

  // 认证相关API
  async register({ username, email, password }) {
    return this.request('/api/register', {
      method: 'POST',
      body: JSON.stringify({ username, email, password })
    })
  }

  async login({ email, password }) {
    return this.request('/api/login', {
      method: 'POST',
      body: JSON.stringify({ email, password })
    })
  }

  async getCurrentUser() {
    return this.request('/api/me', {
      method: 'GET'
    })
  }

  async updateUser({ username, avatarUrl }) {
    return this.request('/api/me', {
      method: 'PUT',
      body: JSON.stringify({ username, avatarUrl })
    })
  }

  async changePassword({ currentPassword, newPassword }) {
    return this.request('/api/me/password', {
      method: 'PUT',
      body: JSON.stringify({ currentPassword, newPassword })
    })
  }

  // 笔记相关API
  async getNotes(params = {}) {
    const queryString = new URLSearchParams(params).toString()
    return this.request(`/api/notes?${queryString}`, {
      method: 'GET'
    })
  }

  async getNote(noteId) {
    return this.request(`/api/notes/${noteId}`, {
      method: 'GET'
    })
  }

  async createNote(noteData) {
    return this.request('/api/notes', {
      method: 'POST',
      body: JSON.stringify(noteData)
    })
  }

  async updateNote(noteId, noteData) {
    return this.request(`/api/notes/${noteId}`, {
      method: 'PUT',
      body: JSON.stringify(noteData)
    })
  }

  async deleteNote(noteId) {
    return this.request(`/api/notes/${noteId}`, {
      method: 'DELETE'
    })
  }

  // 搜索相关API
  async searchNotes(query, params = {}) {
    const queryString = new URLSearchParams(params).toString()
    return this.request(`/api/notes/search/${query}?${queryString}`, {
      method: 'GET'
    })
  }

  async getSearchHistory(params = {}) {
    const queryString = new URLSearchParams(params).toString()
    return this.request(`/api/search-history?${queryString}`, {
      method: 'GET'
    })
  }

  // 标签相关API
  async getPopularTags(params = {}) {
    const queryString = new URLSearchParams(params).toString()
    return this.request(`/api/tags/popular?${queryString}`, {
      method: 'GET'
    })
  }

  // 向量相关API
  async rebuildVectors() {
    return this.request('/api/vectors/rebuild', {
      method: 'POST'
    })
  }

  // 健康检查
  async healthCheck() {
    return this.request('/health', {
      method: 'GET'
    })
  }
}

// 创建单例实例
const apiClient = new ApiClient()

export default apiClient
